import { Badge, Card, Col, Row } from "react-bootstrap";
import { FormatInstance } from "../utils/formatClass";

export const AdminAppFeedbackCardComponent = ({
  feedbackItem,
  onClick,
}: {
  feedbackItem: any;
  onClick: (feedbackItem: any) => void;
}) => {
  // const formatDate = (date: string) => {
  //   const d = new Date(date);
  //   // return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  //   return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
  // };

  return (
    <Card className="shadow-sm" onClick={() => onClick(feedbackItem)}>
      <Card.Body>
        {feedbackItem.feedbackType && (
          <Badge bg="info" className="position-absolute top-0 end-0 m-2">
            {feedbackItem.feedbackType}
          </Badge>
        )}
        <Card.Title className="d-flex align-items-center mb-3">
          <img
            src={feedbackItem.user.avatarUrl}
            alt="user avatar"
            style={{ width: "30px", height: "30px", borderRadius: "50%", marginRight: "10px" }}
          />
          {feedbackItem.user.username}
        </Card.Title>
        <Card.Text className="text-truncate">{feedbackItem.feedback}</Card.Text>
        <Row className="mt-3">
          <Col xs={6} className="text-start">
            <Card.Text className="text-muted" style={{ fontSize: "0.8rem" }}>
              {feedbackItem.user.email}
            </Card.Text>
          </Col>
          <Col xs={6} className="text-end">
            <Card.Text className="text-muted" style={{ fontSize: "0.8rem" }}>
              {FormatInstance.formatDate(feedbackItem.createdAt)}
            </Card.Text>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
